import * as z from 'zod/v4';

import { invertObject, zodEnumFromObjectKeys } from '../utils/entry.js';

export const USYS_VARIANTS = {
  'U0-7-10': 59,
  'U0-10-38': 60,
  'U0-11-65': 61,
  'U3-6-20': 62,
  'U3-6-50': 63,
  'U3-7-98': 64,
  'U4-3-66': 65,
  'U4-4-16': 66,
  'U4-4-44': 67,
  'U4-5-30': 68,
  'U4-5-68': 69,
  'U4-7-200': 70,
  'U5-5-44': 71,
  'U5-5-176': 72,
  'U5-6-274': 73,
  'U6-3-36': 74,
  'U6-4-66': 75,
  'U6-4-224': 76,
  'U7-3-100': 77,
  'U7-4-464': 78,
  'U8-2-253': 79,
  'U8-3-171': 80,
  'U8-3-598': 81,
  'U9-2-202': 82,
  'U11-0-133': 83,
  'U13-0-105': 84,
} as const;

export const USYS_NUM = z.enum(USYS_VARIANTS);
export type USYSNum = z.infer<typeof USYS_NUM>;

export const USYS = zodEnumFromObjectKeys(USYS_VARIANTS);
export type USYS = z.infer<typeof USYS>;

export const USYS_NUMBER_VARIANTS = invertObject<USYS, USYSNum>(USYS_VARIANTS);

/**
 * Checks if a value is a USYS number.
 *
 * @param value numerical value to check
 * @returns Returns true if the value is a valid USYS number
 */
export function isUSYS(value: number): value is USYSNum {
  return value in USYS_NUMBER_VARIANTS;
}
